import React, { useEffect, useState, FormEvent } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux';
import * as auth from '../redux/AuthRedux';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwtDecode from "jwt-decode"; // Default Import

interface DecodedToken {
  role?: string;
  iat?: number;
  [key: string]: any; // To allow other properties
}

type LoginPageType = "Next" | "Login" | "Forgot" | "OTP" | "Pass";

const API_BASE_URL = "https://backendcway.causewaycargo.com/superadmin";

const showToast = (message: string, type: 'success' | 'error') => {
  toast[type](message, {
    position: "top-right",
    autoClose: 2000,
    style: { fontSize: "14px", fontWeight: "bold" },
  });
};

export const Login: React.FC = () => {
  const [loginPage, setLoginPage] = useState<LoginPageType>("Next");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });
  const [who, setWho] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isEmail, setIsEmail] = useState<boolean>(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleApiCall = async (endpoint: string, payload: any) => {
    try {
      const response = await fetch(`https://backendcway.causewaycargo.com/superadmin/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      console.log(`Response from ${endpoint}:`, data);
      if (!response.ok) {
        throw new Error(data.message || 'API call failed');
      }

      return data;
    } catch (error) {
      console.error(`Error in ${endpoint}:`, error);
      throw error;
    }
  };

  const handleNextPage = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.email) {
      showToast("Enter Email/Username!", "error");
      return;
    }

    setLoading(true);
    try {
      const data = await handleApiCall("whologin", { identifier: formData.email });
      const emailType = data?.email.includes(".com");

      showToast("Email Verified Successfully!", "success");
      setLoginPage("Login");
      setWho(data?.role);
      setIsEmail(emailType);

      localStorage.setItem('who', data?.role);
      localStorage.setItem('identifier', formData.email);

      setFormData(prev => ({
        ...prev,
        email: localStorage.getItem('identifier') || ''
      }));
    } catch {
      showToast("Email or Username is invalid!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.email || !who || !formData.password) {
      showToast("Please fill in all fields.", "error");
      return;
    }

    setLoading(true);
    try {
      const data = await handleApiCall("commonlogin", {
        email: formData.email,
        role: who,
        password: formData.password,
      });

      showToast("Login Successful!", "success");
      localStorage.setItem("accessToken", data.token);
      dispatch(auth.actions.login(data.token));

      const decodedToken: DecodedToken = jwtDecode(data.token);
      const { role, iat, ...userData } = decodedToken || {};
      localStorage.setItem("Data", JSON.stringify(userData));

      setTimeout(() => history.push('/dashboard'), 3000);
    } catch (err: any) {
      console.log("Full Error:", err);

      // Directly extract the message if err is already an object
      const errorMessage = err.message || "Login Failed!";
      showToast(errorMessage, "error");

    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.email) {
      showToast("Enter Email!", "error");
      return;
    }

    setLoading(true);
    try {
      await handleApiCall("otpsend", { email: formData.email, role: who });
      showToast("OTP sent successfully!", "success");
      setLoginPage("OTP");
    } catch {
      showToast("Invalid Email!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOTPVerification = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.email || !formData.otp) {
      showToast("Enter OTP!", "error");
      return;
    }

    setLoading(true);
    try {
      await handleApiCall("otpcheck", { email: formData.email, otp: formData.otp, role: who });
      showToast("OTP verified successfully!", "success");
      setLoginPage("Pass");
    } catch {
      showToast("OTP invalid", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSetPassword = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);
    try {
      await handleApiCall("updatepassword", {
        email: formData.email,
        password: formData.password,
        role: who
      });
      showToast("Password reset successfully!", "success");
      setFormData(prev => ({ ...prev, password: "", confirmPassword: "" }));
      setLoginPage("Login");
    } catch {
      showToast("Password reset failed!", "error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getCurrentHandler = () => {
    const handlers = {
      Login: handleLogin,
      Forgot: handleForgotPassword,
      OTP: handleOTPVerification,
      Pass: handleSetPassword,
      Next: handleNextPage,
    };
    return handlers[loginPage];
  };
  console.log("loginPage", loginPage)
  console.log("confirmPassword", formData.password)

  return (
    <>

      <div className="container d-flex justify-content-center align-items-center">

        <div className="w-100">

          {(loginPage === "Forgot") && <svg xmlns="http://www.w3.org/2000/svg" onClick={() => {
            setFormData(prevData => ({
              ...prevData,
              otp: ""
            }));
            setLoginPage("Login")
          }} height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>}
          {(loginPage === "OTP") && <svg xmlns="http://www.w3.org/2000/svg" onClick={() => {
            setLoginPage("Forgot")

            setFormData(prevData => ({
              ...prevData,
              otp: ""
            }));
            setLoginPage("Forgot");
          }} height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>}
          {(loginPage === "Pass") && <svg xmlns="http://www.w3.org/2000/svg" onClick={() => {
            setFormData(prevData => ({
              ...prevData,
              otp: ""
            }));
            setLoginPage("Forgot")
          }
          } height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>}
          <form onSubmit={getCurrentHandler()} className="p-4">
            <div className="mb-4">
              <div className="text-center mb-4">
                <h1
                  className={`text-black ${loginPage === "Forgot" || loginPage === "OTP" || loginPage === "Pass" ? "text-4xl" : "display-4"
                    }`}
                >
                  {loginPage === "Next" || loginPage === "Login"
                    ? "Login"
                    : loginPage === "Forgot"
                      ? "Forgot Password"
                      : loginPage === "OTP"
                        ? "Enter OTP"
                        : "Set New Password"}
                </h1>


              </div>

              {loginPage !== "Pass" && (
                <>

                  <div className="fv-row mb-4">
                    <label className="form-label fs-6 fw-bolder text-black">
                      Email or Username <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-control form-control-lg form-control-solid"
                      placeholder={`Enter ${isEmail ? "Email" : "Email or Username"}`}
                      disabled={loading || loginPage === "Login" || loginPage === "Forgot" || loginPage === "OTP"}
                    />
                  </div></>
              )}


              {(loginPage === "Login" || loginPage === "Pass") && (
                <div className="fv-row mb-4">
                  <label className="form-label fs-6 fw-bolder text-black">
                    Password
                    <span className="text-danger"> *</span></label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="form-control form-control-lg form-control-solid"
                      placeholder="Enter Password"
                      disabled={loading}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
                      style={{ cursor: 'pointer' }}
                    >
                      {showPassword ? (
                        <FaEyeSlash className="text-muted" />
                      ) : (
                        <FaEye className="text-muted" />
                      )}
                    </button>
                  </div>
                  {(loginPage === "Login" && who !== "super_admin") && <p
                    className="text-end text-black mt-2"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setLoginPage("Forgot")}
                  >
                    Forgot password?
                  </p>}
                </div>
              )}
            </div>
            {(loginPage === "OTP") && (
              <div className="fv-row mb-4">
                <label className="form-label fs-6 fw-bolder text-black">
                  Otp
                  <span className="text-danger"> *</span></label>
                <div className="position-relative">
                  <input
                    type="text"
                    name="otp"
                    value={formData.otp}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,4}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    className="form-control form-control-lg form-control-solid"
                    placeholder="Enter OTP"
                    disabled={loading}
                    maxLength={4}
                  />

                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
                    style={{ cursor: 'pointer' }}
                  >
                  </button>

                </div>

              </div>
            )}


            <div className="d-grid mb-4">
              <button type="submit" className="btn" disabled={loading} style={{backgroundColor: 'rgb(196, 42, 33)', color: 'white'}}>
                {loading ? "Processing..." : loginPage === "Next" ? "Next" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
